import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";

// Config
import connectConfig from "../config/connectConfig";

// CSS
import "@/styles/page/systemSettingProductPage.css";
import "@/styles/page/employeeShopping.css";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";
import Box from "@mui/material/Box";
import { questionnaireReportListColumn } from "@/config/tableColumnConfig";

// Fetch
import { getQuestionnarieSettings } from "@/fetch/fetchQuestionnarie";

const QuestionnaireReportListPage = (props) => {
  const { open, setOpen } = props;

  // Navigate
  const navigate = useNavigate();

  // States
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  // Browser Back
  const handleBeforeUnload = (e) => {
    e.preventDefault();
    const message =
      "Are you sure you want to leave? All provided data will be lost.";
    e.returnValue = message;
    return message;
  };

  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      const { data: replyQuestData } = await getQuestionnarieSettings();
      if (replyQuestData) setData(replyQuestData);
    } catch (err) {
      console.log(err);
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAll();
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="StaffManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      open={open}
      setOpen={setOpen}
    >
      <Title
        title={`問卷表格`}
        history={() => navigate(-1)}
        children={<div></div>}
      />

      <StyledPaper page={"yes"}>
        <ThemeProvider theme={{}}>
          <Box sx={{ width: "100%" }}>
            <DataTable
              loading={dataTableLoading}
              rows={data}
              columns={questionnaireReportListColumn}
              pageSize={100}
              onRowClick={(param) => {
                navigate(`/questionnaireReport/${param.id}`);
              }}
            />
          </Box>
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default QuestionnaireReportListPage;
